import React from 'react';
import { SERVICESLIST } from '../data/services';
import styles from '../styles/ServicesList.module.css';
import { Link } from 'react-router-dom';

const STATS = [
  { num: "80+", label: "Accounts" },
  { num: "15+", label: "Experience" },
  { num: "100%", label: "Success Rate" },
];

export default function ServicesList() {
  return (
    <section className={styles.section} id="services-list">
      <div className="container">
        <div className="row align-items-start g-5">
          {/* ── Sidebar ── */}
          <div className="col-lg-4">
            <div className={styles.sidebar}>
              <p className={styles.sideLabel}>Explore All</p>
              <h2 className={styles.sideTitle}>Every Service, <br /> Built for Results</h2>
              <p className={styles.sideDesc}>
                Each offering is designed to fill your calendar with qualified
                discovery calls, so your team can focus on closing, not chasing.
              </p>
              <Link to="/contact" className={styles.sideBtn}>
  Get Started →
</Link>

              <div className={styles.statsRow}>
                {STATS.map((s) => (
                  <div className={styles.stat} key={s.label}>
                    <span className={styles.statNum}>{s.num}</span>
                    <span className={styles.statLabel}>{s.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── List ── */}
          <div className="col-lg-8">
            <div className={styles.list}>
              {SERVICESLIST.map((svc) => (
                <div 
                  key={svc.title} 
                  className={styles.listItem}
                  /* Match IDs to the hrefs in your SERVICES data */
                  id={
                    svc.title === "Inbox to Invite" ? "email-detail" :
                    svc.title === "Dials to Discovery Calls" ? "phone-detail" :
                    svc.title === "Full Spectrum Outreach" ? "multi-detail" :
                    svc.title === "Reach at Scale" ? "growth-detail" :
                    svc.title === "Outcome-Driven Outreach" ? "outcome-driven-detail" :
                    undefined
                  }
                >
                  <div className={styles.listIcon} aria-hidden="true">
                    {svc.title === "Inbox to Invite" ? (
                      <div className={styles.envBase}><div className={styles.envFlap}></div></div>
                    ) : svc.title === "Full Spectrum Outreach" ? (
                      <span className={styles.linkIcon}>{svc.icon}</span>
                    ) : svc.title === "Reach at Scale" ? (
                      <span className={styles.rocketShip}>{svc.icon}</span>
                    ) : svc.title === 'Dials to Discovery Calls' ? (
                      <span className={styles.phoneHandset}>{svc.icon}</span>
                    ) : svc.title === "Outcome-Driven Outreach" ? (
                      <div className={styles.targetWrapper}>
                        <span className={styles.targetIcon}>{svc.icon}</span>
                        <span className={styles.flyingArrow}>➹</span>
                      </div>
                    ) : (
                      <span className={styles.iconElement}>{svc.icon}</span>
                    )}
                  </div>

                  <div className={styles.listBody}>
                    <p className={styles.listTitle}>{svc.title}</p>
                    {svc.para && <p className={styles.listDesc}>{svc.para}</p>}
                    {Array.isArray(svc.desc) && (
                      <ul className={styles.pointsList}>
                        {svc.desc.map((point, index) => (
                          <li key={index} className={styles.pointItem}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>

                 <Link to="/contact" className={styles.listArrow} aria-label="View Service">
  →
</Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
